import React from 'react'

export default function MujeresEmbarazadas() {
  return (
    <div>MujeresEmbarazadas</div>
  )
}
